import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { returnToState } from '@/helpers/returnTo';
import editIcon from '@/assets/icons/edit-pencil.svg';
import DocumentRow from './DocumentRow';
import styles from '../FundSettings.module.css';

const enabledRoutes: string[] = import.meta.env.VITE_APP_ENABLED_ROUTES ?? [];

/*
 * The forms belong to Merkaz HaTzdaka in Israel: a site whose enabled routes do not list a form
 * (אח לאח, the US site) shows no row for it, and with neither the panel is not there at all.
 */
const OPEN_FUND_FORMS = [
  { to: '/open-fund/welfare', nameKey: 'openFundEntry.welfare' },
  { to: '/open-fund/community', nameKey: 'openFundEntry.community' },
].filter((form) => enabledRoutes.includes(form.to));

/**
 * «פתיחת פרויקט חדש» at the foot of «אישורים ומסמכים» (HAT-1370): a coordinator looking for the
 * fund-opening form looks among the forms. Last on the page, because it is not about the project
 * that is selected. The only way in from the personal area - the menu has none (Chaya, 8.10: one
 * place, not two).
 *
 * Not the referral line Druk removed on 4.10 - that one sent to the landing site's copy of the
 * forms, for passing on to someone else. These open the form here, and closing it comes back to
 * this screen (helpers/returnTo).
 */
const OpenFundSection = () => {
  const { t } = useTranslation();
  const location = useLocation();

  if (OPEN_FUND_FORMS.length === 0) return null;

  return (
    <div className={styles.panel}>
      <h2 className={styles.panelTitle}>{t('openFundEntry.title')}</h2>
      <p className={styles.panelSubtitle}>{t('openFundEntry.documentsSubtitle')}</p>
      <div className={styles.documentList}>
        {OPEN_FUND_FORMS.map((form) => (
          <DocumentRow key={form.to} name={t(form.nameKey)}>
            <Link to={form.to} state={returnToState(location.pathname, location.search)} className={styles.linkBtn}>
              <img src={editIcon} alt="" className={styles.actionIcon} />
              {t('openFundEntry.fillForm')}
            </Link>
          </DocumentRow>
        ))}
      </div>
    </div>
  );
};

export default OpenFundSection;
